export const typeVasActionTypes = {
  GET_TYPE_VAS: 'GET_TYPE_VAS',
  GET_TYPE_VAS_EXITO: 'GET_TYPE_VAS_EXITO',
  GET_TYPE_VAS_ERRROR: 'GET_TYPE_VAS_ERRROR'
}
